import script from "./login_acceso.vue?vue&type=script&setup=true&lang=js"
export * from "./login_acceso.vue?vue&type=script&setup=true&lang=js"

import "./login_acceso.vue?vue&type=style&index=0&id=2a5257d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a5257d2"]])

export default __exports__